'use strict';

module.exports = hysdk.util.extend({}, require('./login'), require('./share'), require('./device'), require('./scan'), require('./image'), require('./log'), require('./webview'), require('./navigation'), require('./pay'), require('./window'), require('./scheme'));


//////////////////
// WEBPACK FOOTER
// ../plugins/ctrip/apis/index.js
// module id = 42
// module chunks = 1 4